<template>
  <main class="galleries-page page">
    <BreadcrumbsComponent title="События" />
    <div class="container-padding">
      <div v-if="galleries && galleries.length" class="galleries-page__inner">
        <LoadingIndicator v-if="loading" title="Загрузка" />
        <div v-if="!loading" class="galleries-page__content">
          <GalleriesCardComponent v-for="(gallery, i) in galleries" :key="i" :gallery="gallery" />
        </div>
        <PaginationComponent
          :first="first"
          :page="page"
          :total="Math.ceil(total / first)"
          :totalItems="parseInt(total || '0')"
          @paginate="paginate"
        />
      </div>
      <h2 v-else class="no-info">В данный момент информация отсутствует</h2>
    </div>
  </main>
</template>

<script>
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import GalleriesCardComponent from "./components/GalleriesCardComponent.vue";
import PaginationComponent from "components/PaginationComponent.vue";
import GALLERIES_PAGE from "gql/pages/GalleriesPage.graphql";
import LoadingIndicator from "components/LoadingIndicator.vue";

export default {
  name: "GalleriesPage",
  metaInfo: {
    title: "События",
  },
  async asyncData({ apollo, store }) {
    let variables = {
      page: 1,
      first: 6,
    };
    await apollo.defaultClient
      .query({
        query: GALLERIES_PAGE,
        variables: variables,
      })
      .then(({ data }) => {
        store.dispatch("galleries/save", data);
      });
  },
  data() {
    return {
      page: 1,
      first: 6,
      loading: false,
    };
  },
  computed: {
    galleries() {
      return this.$store.state.galleries.galleries.data;
    },
    total() {
      return this.$store.state.galleries.galleries.paginatorInfo.total;
    },
  },
  methods: {
    paginate(e) {
      this.page = e;
      this.fetch();
    },
    fetch() {
      if (!this.loading) {
        this.loading = true;
        let variables = {
          page: this.page,
          first: this.first,
        };
        this.$apollo
          .query({
            query: GALLERIES_PAGE,
            variables: variables,
          })
          .then(({ data }) => {
            this.$store.dispatch("galleries/save", data);
            this.loading = false;
          });
      }
    },
  },
  components: {
    LoadingIndicator,
    BreadcrumbsComponent,
    GalleriesCardComponent,
    PaginationComponent,
  },
};
</script>

<style lang="stylus">
.galleries-page {

  &__inner {
    padding 50px 0 0 0
    display grid
    grid-gap 50px
  }

  &__content {
    display grid
    grid-template-columns 1fr 1fr
    grid-gap 30px 20px
    +below(900px) {
      grid-template-columns 1fr
    }
  }
}
</style>
